<template>
  <div class="SetValue-workFlow">
    <div class="content-row">
      <div v-if="['time', 'date'].includes(type)" class="row-left">
        <div v-if="flowVarVisible" class="var-container">
          <span class="var">{{ flowVar.label }}</span>
          <div class="icon-close" @click="hideFlowVar">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <NormalSelect
          v-else
          class="normal-select"
          size="normal"
          :selectList="type | getValListByType"
          :selectedItem.sync="selectedItem"
          @handle-select="selectVal"
        ></NormalSelect>
      </div>

      <group-dropdown-menu class="item-menu" :group-list="workflowVarList" @select="selectFlowVar">
        <el-tooltip effect="dark" content="使用本流程节点对象的值" placement="bottom-end">
          <div
            class="btn-add buttonSelectTrigger"
            :style="flowVarVisible ? 'height:43px' : 'height:40px'"
          >
            <i class="el-icon-plus"></i>
          </div>
        </el-tooltip>
      </group-dropdown-menu>
    </div>
    <el-date-picker
      v-if="showItem == 'timePicker' && !flowVarVisible"
      v-model="time"
      type="datetime"
      placeholder="指定日期时间"
      default-time="00:00:00"
      value-format="yyyy-MM-dd HH:mm:ss"
      class="date-select"
      @change="setVal('指定时间')"
    ></el-date-picker>
  </div>
</template>

<script>
import NormalSelect from "@/components/UIComponents/NormalSelect"
import Filters from "../../mixin/filters"
import GroupDropdownMenu from "@/components/UIComponents/GroupDropdownMenu/GroupDropdownMenu"
import { transOldExpr } from "@/utils/workFlow"
export default {
  name: "SetValue-workFlow",
  components: {
    NormalSelect,
    GroupDropdownMenu
  },
  props: {
    type: String,
    flowConnectedData: Array,
    info: Object,
    workflowVarList: Array
  },
  data() {
    return {
      value: "",
      time: "",
      flowVarVisible: false,
      flowVar: {},
      selectList: [],
      selectedItem: "",
      showItem: ""
    }
  },
  mixins: [Filters],
  created() {
    switch (this.type) {
      case "time":
      case "date": {
        if (this.info.inFlow) {
          this.flowVarVisible = true
          this.flowVar = Object.assign(
            {},
            {
              label: this.info.label,
              value: transOldExpr(this.info.value)
            }
          )
        } else if (this.info.label == "指定时间") {
          this.showItem = "timePicker"
          this.selectedItem = "指定时间"
          this.time = this.info.value
        } else {
          this.selectedItem = this.info.value
        }
        break
      }
    }
  },
  methods: {
    selectFlowVar(item) {
      switch (this.type) {
        case "time":
        case "date": {
          this.flowVar = {
            label: item.label,
            value: item.value
          }
          this.flowVarVisible = true
          this.$emit("updateInfo", {
            label: this.flowVar.label,
            value: this.flowVar.value,
            inFlow: true
          })
          break
        }
      }
    },
    hideFlowVar() {
      this.flowVarVisible = false
      switch (this.type) {
        case "time":
        case "date": {
          this.setVal(this.selectedItem)
          break
        }
      }
    },
    selectVal(item) {
      this.setVal(item.value)
    },
    setVal(value = null) {
      switch (this.type) {
        case "time":
        case "date": {
          let val
          if (value == "指定时间") {
            this.showItem = "timePicker"
            val = this.time
          } else {
            this.showItem = ""
            val = value
          }
          this.$emit("updateInfo", {
            label: value,
            value: val,
            inFlow: false
          })
          break
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.SetValue-workFlow {
  margin-top: 10px;
  .content-row {
    display: flex;
    position: relative;
    .row-left {
      flex: 1 1;
    }
    .normal-select {
      margin-top: 0;
    }
    .var-container {
      position: relative;
      padding: 0 10px;
      background: #f8f8f8;
      border: 1px solid #ccc;
      line-height: 41px;
      border-radius: 4px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      box-sizing: border-box;
      &:hover {
        border-color: #2196f3;
      }
      .var {
        display: inline-flex;
        margin-bottom: 5px;
        line-height: 28px;
        padding: 1px;
        font-size: 14px;
        color: #606266;
      }
      .icon-close {
        position: absolute;
        top: 0;
        right: 10px;
        width: 20px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          color: #1e88e5;
        }
      }
    }
    .btn-add {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-width: 1px 1px 1px 0;
      border-style: solid;
      box-sizing: border-box;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-color: #ddd;
      font-size: 20px;
      color: #9e9e9e;
      cursor: pointer;
      &:hover {
        color: #1e88e5;
      }
    }
  }
  .date-select {
    margin-top: 10px;
    width: 100%;
  }
}
</style>

<style lang="scss">
.SetValue-workFlow {
  .content-row {
    .normal-select {
      .el-input__inner {
        border: 1px solid #ccc;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        &:hover {
          border-color: #2196f3;
        }
      }
    }
  }
}
</style>
